import { getOpenIDUrl } from '@/api';
import { LOGIN_TYPE } from '@/pages/PC/SelectLogin';

export const authLogin = async (meetingId: string, pwd: string, provider?: LOGIN_TYPE) => {
  const res = await getOpenIDUrl(meetingId, encodeURIComponent(pwd), provider);
  if (res.data) {
    window.location.href = res?.data;
  }
};
